import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'lh-login-option-popup',
  templateUrl: './login-option-popup.html',
  styleUrls: ['./login-option-popup.scss'],
})
export class LoginOptionPopupComponent {
  constructor(public dialogRef: MatDialogRef<LoginOptionPopupComponent>) {}

  closeModal(eventType?: string) {
    this.dialogRef.close(eventType);
  }
}
